import React, { useEffect, useState } from 'react';
import { fetch } from '@fishx/rest';
import { connect } from 'react-redux';
import { set, get } from 'dot-prop-immutable';
import { getLocale } from '@utils/util';
import { message } from '@whalecloud/fdx';
import { getActiveElement } from '@whalecloud/page-builder-core/selectors';
import CommonCodeDrawer from '@whalecloud/page-builder-base-components/components/CommonCodeDrawer';

const defaultRemote = {
  url: 'https://mock.iwhalecloud.com/mock/1889/transferList',
  method: 'GET',
  params: {},
};

const OptionSettings = (props: any) => {
  const messages = getLocale();
  const { updateElement, element, sourceKey } = props;
  const { data: { componentSettings = {} } = {} } = element;
  const { autoInitialize = false } = componentSettings;
  const [remoteCodeUrl, setRemoteCodeUrl] = useState({});

  const valueKey = sourceKey;

  useEffect(() => {
    const code = get(element, 'data.componentSettings.remoteUrl');
    setRemoteCodeUrl(code || defaultRemote);
    onCreate(code || defaultRemote);
  }, []);

  const onCreate = async (code: any) => {
    const { url = '', method = 'GET', params = {} } = code;
    if (autoInitialize) {
      try {
        const { data } = await fetch(url, {
          method,
          data: { ...params },
        });
        if (data) {
          const listValue = [...data];
          let newElement = set(element, `${valueKey}.dataList`, listValue);
          newElement = set(newElement, `${valueKey}.remoteUrl`, code);
          updateElement({
            element: newElement,
          });
          message.success(messages['PAGEBUIDER_MSG_OPTIONS_REMOTE_SUCCESS']);
        } else {
          message.error(messages['PAGEBUIDER_MSG_OPTIONS_REMOTE_FAIL']);
        }
      } catch (error) {
        message.error(messages['PAGEBUIDER_MSG_OPTIONS_REMOTE_FAIL']);
      }
    } else {
      const newElement = set(element, `${valueKey}.remote`, code);
      updateElement({
        element: newElement,
      });
      message.warn(messages['PAGEBUIDER_MSG_OPTIONS_REMOTE_WARN']);
    }
  };

  const CodeDrawerProps = {
    value: remoteCodeUrl ? JSON.stringify(remoteCodeUrl, null, '\t') : JSON.stringify({}, null, '\t'),
    onClose: onCreate,
    title: `${messages['PAGEBUIDER_TITLE_REMOTE']}(JSON)`,
    buttonText: messages['PAGEBUIDER_TITLE_REMOTE'],
  };

  return (
    <React.Fragment>
      <div style={{ textAlign: 'center' }}>
        <CommonCodeDrawer {...CodeDrawerProps} />
      </div>
    </React.Fragment>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  updateElement: (payload: any) => {
    dispatch({
      type: 'appBuilder/updateAndFlattenElement',
      payload,
    });
  },
});

export default connect<any, any, any>(state => ({ element: getActiveElement(state) }), mapDispatchToProps)(OptionSettings);
